import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_URL || "/api/v2";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) { setError("Passwords do not match."); return; }
    if (password.length < 8) { setError("Password must be at least 8 characters."); return; }
    const token = searchParams.get("token");
    if (!token) { setError("Invalid reset link."); return; }
    setStatus("loading");
    setError("");
    try {
      const res = await fetch(`${API_BASE}/auth/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token, password }),
      });
      const data = await res.json();
      if (data.success) {
        setStatus("done");
        setTimeout(() => navigate("/login"), 3000);
      } else {
        setError(data.message || "Reset failed. Link may have expired.");
        setStatus("idle");
      }
    } catch {
      setError("Network error. Please try again.");
      setStatus("idle");
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-blue-950 to-indigo-950 flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        <div className="text-center mb-8">
          <img src="/logo.png" alt="ZoomPay" style={{height: "90px", width: "auto", margin: "0 auto"}} />
          <p className="text-blue-300 text-sm mt-2">Send Money to Africa, Instantly</p>
        </div>
        <div className="bg-white rounded-2xl shadow-xl p-8">
          {status === "done" ? (
            <div className="text-center">
              <div className="text-5xl mb-4">✅</div>
              <h2 className="text-xl font-bold text-slate-900 mb-2">Password Reset!</h2>
              <p className="text-gray-500 text-sm mb-6">Your password has been updated. Redirecting to login...</p>
              <button onClick={() => navigate("/login")}
                className="w-full py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-xl transition">
                Go to Login
              </button>
            </div>
          ) : (
            <>
              <h2 className="text-2xl font-bold text-slate-900 mb-1 text-center">Reset Password</h2>
              <p className="text-center text-gray-500 text-sm mb-6">Enter your new password below.</p>
              {error && <div className="bg-red-50 border border-red-200 text-red-700 rounded-lg p-3 text-sm mb-4">{error}</div>}
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">New Password</label>
                  <input type="password" value={password} onChange={e => setPassword(e.target.value)}
                    required placeholder="Min 8 characters"
                    className="w-full border border-gray-300 rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Confirm Password</label>
                  <input type="password" value={confirm} onChange={e => setConfirm(e.target.value)}
                    required placeholder="Repeat password"
                    className="w-full border border-gray-300 rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500" />
                </div>
                <button type="submit" disabled={status === "loading"}
                  className="w-full py-3 bg-blue-600 hover:bg-blue-700 disabled:opacity-60 text-white font-semibold rounded-xl transition">
                  {status === "loading" ? "Resetting..." : "Reset Password"}
                </button>
              </form>
            </>
          )}
        </div>
        <p className="text-center text-blue-400 text-xs mt-6">FINTRAC MSB C10001588 · ZoomPay Systems & Technology Ltd.</p>
      </div>
    </div>
  );
}
